import { IFormParty } from '../../interfaces';
import { IPropertyAddress } from 'ui-toolkit/orders/interfaces/IPropertyAddress';
import { DateTime } from 'luxon';
import { ePartyPurpose } from '../../../../ui-toolkit/enums/ePartyPurpose';
import { ePartyType } from '../../../../ui-toolkit/enums/ePartyType';
import { IParty } from '../../../../ui-toolkit/orders/interfaces/IParty';

export const cleanParty = (start: IFormParty): IParty => {
  const purpose = start.purpose === ePartyPurpose.buyer ? ePartyPurpose.borrower : start.purpose;
  const address: IPropertyAddress | undefined =
    start.address && start.address.street_address && start.address.city && start.address.state && start.address.zip_code
      ? {
          street_address: start.address.street_address,
          city: start.address.city,
          state: start.address.state,
          zip_code: start.address.zip_code,
          unit: start.address.unit,
          countyFips: null,
          countyName: null,
          countyState: null,
        }
      : undefined;
  if (start.type === ePartyType.person) {
    let date_of_birth: string | undefined = start.date_of_birth
      ? DateTime.fromISO(start.date_of_birth).toISODate()
      : undefined;
    return {
      id: start.id,
      type: start.type,
      purpose,
      first_name: start.first_name,
      middle_name: start.middle_name,
      last_name: start.last_name,
      ssn: start.ssn,
      marital_status: start.marital_status,
      email: start.email,
      phone_number: start.phone_number,
      registered: start.registered,
      party_sequence: start.party_sequence,
      lender_user_id: start.lender_user_id,
      date_of_birth,
      address,
    };
  }
  return {
    id: start.id,
    type: start.type,
    purpose,
    entity_name: start.entity_name,
    entity_type: start.entity_type,
    party_sequence: start.party_sequence,
    signatories: start.signatories.map((t) => ({
      ...t,
      id: t.isNew ? undefined : t.id,
      address:
        t.address && t.address.street_address && t.address.city && t.address.state && t.address.zip_code
          ? t.address
          : undefined,
    })),
    address,
  };
};
